/**
 * O vocabulário das indicações de conexão, compartilhado com a SPA.
 *
 * Módulo próprio, e não um pedaço de `index.ts`, pelo motivo documentado em
 * `package.json` e em `vite.config.ts`: importar a raiz de `@mpa/shared` traz
 * `phone.ts` junto, e com ele os metadados completos do libphonenumber (~150KB)
 * que só o servidor usa. A tela de revisão precisa de catorze strings.
 *
 * A raiz reexporta, então a API continua importando de `@mpa/shared`.
 */

/**
 * Os catorze estados de uma indicação, em português.
 *
 * ⚠️ **As catorze chaves têm de cobrir o enum `RecommendationStatus` inteiro.** Um
 * estado sem rótulo apareceria na tela como `OPORTUNIDADE_IDENTIFICADA`, em caixa
 * alta e com sublinhado, para o cliente. `recomendacoes.spec.ts` na API percorre
 * o enum do schema e falha se faltar um.
 */
export const ROTULOS_DA_RECOMENDACAO = {
  GERADA: 'Gerada',
  AGUARDANDO_APROVACAO: 'Aguardando aprovação',
  APROVADA: 'Aprovada, a caminho',
  REJEITADA: 'Rejeitada na revisão',
  ENVIADA: 'Enviada',
  ENTREGUE: 'Entregue',
  VISUALIZADA: 'Visualizada',
  ACEITA: 'Aceita',
  RECUSADA: 'Recusada pela pessoa',
  CONTATO_INICIADO: 'Contato iniciado',
  REUNIAO_REALIZADA: 'Reunião realizada',
  OPORTUNIDADE_IDENTIFICADA: 'Oportunidade identificada',
  FOLLOWUP_NECESSARIO: 'Precisa de acompanhamento',
  SEM_RETORNO: 'Sem retorno',
} as const;

export type StatusDaRecomendacao = keyof typeof ROTULOS_DA_RECOMENDACAO;
